import React from 'react';
import { Box } from '@mui/material';
import {
  Hero,
  WhyUs,
  About,
  Testimonials,
  Team,
  Contact,
} from '../../components/sections';

const Home = () => {
  return (
    <Box>
      <Hero />
      <WhyUs />
      <About />
      <Testimonials />
      <Team />
      <Contact />
    </Box>
  );
};

export default Home;
